import {apiRequest} from './apiClient';

const HOST = 'https://beneficios.malldelpacifico.com.ec/calendariodeadviento/';
const API_BASE_URL = 'https://apicapmanias.umpacto.com';
const shoppingCenterId = 7;

// Notificación
const toast = (message) => {
    Swal.fire({
        text: message,
        confirmButtonColor: '#24705e',
    });
}

// Función para validar el número de cédula
const isCedulaValid = (cedula) => {
    let total = 0;
    const longitud = cedula.length;
    const longcheck = longitud - 1;

    if (cedula !== "" && longitud === 10) {
        for (let i = 0; i < longcheck; i++) {
            let aux = parseInt(cedula.charAt(i));
            if (i % 2 === 0) {
                aux *= 2;
                if (aux > 9) aux -= 9;
            }
            total += aux;
        }

        total = total % 10 ? 10 - (total % 10) : 0;

        return cedula.charAt(longitud - 1) === total.toString();
    }

    return false;
};

// Establece el logo y el fondo
const setImages = () => {
    // Obtener el objeto 'shopping' del localStorage
    const shoppingData = localStorage.getItem("shopping");

    // Validar que el objeto exista
    if (shoppingData) {
        try {
            // Parsear el JSON para obtener un objeto
            const shopping = JSON.parse(shoppingData);

            // Establecer la imagen del logo
            const logoElement = document.getElementById("logo");
            if (logoElement && shopping.logoUrl) {
                logoElement.src = `${API_BASE_URL}${shopping.logoUrl}`;
            }

            // Establecer la imagen de fondo
            const fondoElement = document.getElementById("fondo");
            if (fondoElement && shopping.fondoUrl) {
                fondoElement.style.backgroundImage = `url('${API_BASE_URL}${shopping.fondoUrl}')`;
            }
        } catch (error) {
            console.error("Error al parsear los datos de shopping:", error);
        }
    } else {
        console.warn("No se encontró la información de 'shopping' en localStorage.");
    }
}

// Validar código de registro de usuario
const handleValidateCodeSubmit = (event) => {
    event.preventDefault();

    const code = document.getElementById('code').value;

    // Obtener el valor del parámetro 'email' de la URL
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams.get('email');

    if (!email) {
        toast('Url incorrecta: no se encontró el parámetro email');
        return;
    }

    // Datos a enviar
    const userData = {
        email,
        code
    };

    apiRequest('/auth/verify', 'POST', userData)
        .then(response => {

            toast("Gracias por validar tu cuenta.");

            setTimeout(() => {
                window.location.href = `${HOST}iniciar-sesion.html?email=${userData.email}`;
            }, 700);

        })
        .catch(error => {
            toast("Error al validar la cuenta");
        });
}

// Registro de usuarios
const handleRegistroSubmit = (event) => {
    event.preventDefault();

    // Verificar si los checkboxes de términos y política están seleccionados
    const acceptTerms = document.getElementById('accept-terms').checked;
    const acceptPolicy = document.getElementById('accept-policy').checked;

    if (!acceptTerms || !acceptPolicy) {
        toast("Debes aceptar los Términos y condiciones y la Política de Protección de Datos.");
        return;
    }

    // Obtener el tipo de identificación y validar el campo 'cedula' según corresponda
    const tipoIdentificacion = document.getElementById('tipo-identificacion').value;
    const cedula = document.getElementById('cedula').value;

    // Validación adicional para el campo 'cedula' en función del tipo de identificación
    if ((tipoIdentificacion === 'CÉDULA' && cedula.length !== 10) ||
        (tipoIdentificacion === 'RUC' && cedula.length !== 13)) {
        toast("El número de identificación no cumple con la longitud requerida.");
        return;
    }

    // Continuar con la validación del resto de campos
    const nombre = document.getElementById('nombre').value;
    const lastName = document.getElementById('apellido').value;
    const genero = document.getElementById('genero').value;
    const fechaNacimiento = document.getElementById('fecha-nacimiento').value;
    const celular = document.getElementById('celular').value;
    const email = document.getElementById('email').value;
    const password = document.getElementById('password').value;

    if (!cedula || !nombre || !genero || !fechaNacimiento || !celular || !email || !lastName || !password) {
        toast("Por favor, completa todos los campos.");
        return;
    }

    if (tipoIdentificacion === "CÉDULA" && !isCedulaValid(cedula)) {
        Swal.fire({
            icon: 'error',
            title: 'Cédula inválida',
            text: 'Por favor, ingrese un número de cédula válido.'
        });
        return;
    }

    // Datos a enviar al backend
    const userData = {
        "tipoIdentificacion": tipoIdentificacion,
        "cedula": cedula,
        "firstName": nombre,
        "lastName": lastName,
        "gender": genero,
        "birthDate": fechaNacimiento,
        "phone": celular,
        "email": email,
        password,
        shoppingId: shoppingCenterId,
    };

    apiRequest('/user', 'POST', userData)
        .then(user => {
            toast(`Bienvenido ${user.firstName}! revisa tu bandeja de entrada.`);
            setTimeout(() => {
                window.location.href = `${HOST}validar_cuenta.html?email=${user.email}`;
            }, 600);
        })
        .catch(error => {
            toast("Gracias tu registro ya puedes iniciar sesión.");
            setTimeout(() => {
                window.location.href = `${HOST}iniciar-sesion.html?email=${email}`;
            }, 600);
        });
};

// Login
const handleLoginSubmit = (event) => {
    event.preventDefault();
    // Capturar y validar los datos del formulario de login
    const email = document.getElementById('email').value;
    const password = document.getElementById('password').value;

    // Datos a enviar
    const userData = {
        email,
        password,
        shoppingCenterId,
    };

    apiRequest('/auth/login', 'POST', userData)
        .then(response => {
            const user = response.user;
            const access_token = response.access_token;
            // const shopping = response.shopping;
            const userShoppingCenter = response.userShoppingCenter;

            // Guardamos las credenciales de acceso
            localStorage.setItem('access_token', access_token);
            localStorage.setItem('user', JSON.stringify(user));
            // localStorage.setItem('shopping', JSON.stringify(shopping));

            toast(`Bienvenido, ${user.firstName}`);

            setTimeout(() => {
                window.location.href = (userShoppingCenter?.isRegistered) ? `${HOST}calendario.html` : `${HOST}subir-factura.html`;
            }, 600);

        })
        .catch(error => {
            toast("Usuario o contraseña no son correctos");
        });
};

// recuperar contraseña
const handleForgotPasswordForm = (event) => {
    event.preventDefault();
    // Capturar y validar los datos del formulario de login
    const email = document.getElementById('email-forgot-password').value;

    // Datos a enviar
    const userData = {
        email,
        shoppingCenterId,
    };

    apiRequest('/auth/recover-password', 'POST', userData)
        .then(response => {

            toast(response?.message);

            setTimeout(() => {
                window.location.href = `${HOST}index.html`;
            }, 600);

        })
        .catch(error => {
            toast("Error al recuperar la contraseña.");
        });
};

// Obteiene informacion del juego y centro comercial
const handleDataFetch = async () => {
    try {
        // Obtener los parámetros de la URL
        const urlParams = new URLSearchParams(window.location.search);
        const ccParamId = urlParams.get('cc'); // variable solo para administradores
        const gameId = urlParams.get('g');

        // Validar que los parámetros sean números
        const isGameIdValid = gameId && !isNaN(gameId);
        const isCCIdValid = ccParamId && !isNaN(ccParamId);

        const shoppingData = await apiRequest(`/shopping-center/${(isCCIdValid) ? ccParamId : shoppingCenterId}`);
        localStorage.setItem('shopping', JSON.stringify(shoppingData));

        if (isGameIdValid) {
            try {
                const gameData = await apiRequest(`/games/${gameId}`);
                localStorage.setItem('game', JSON.stringify(gameData));
                console.log('Datos del juego guardados:', gameData);
            } catch (error) {
                console.error('Error al obtener datos del juego');
            }
        }
        setImages();

    } catch (error) {
        console.error('Error al obtener datos del shopping center');
    }
};

document.addEventListener('DOMContentLoaded', () => {
    // Crea los localstorages
    handleDataFetch();

    // Manejo del formulario de registro
    const registroForm = document.getElementById('registro-form');

    // Obtener el valor del parámetro 'email' de la URL y llenar el input si existe
    const urlParams = new URLSearchParams(window.location.search);
    const email = urlParams.get('email');

    const emailLogin = document.getElementById('email');
    const code = urlParams.get('code');

    // Si existe 'code', lo establecemos en el input
    if (code) {
        document.getElementById('code').value = code;
    }

    // formulario de registro
    if (registroForm) {
        registroForm.addEventListener('submit', handleRegistroSubmit);
    }

    // Manejo del formulario de validacion de cuenta
    const validateForm = document.getElementById('validate-form');
    if (validateForm) {
        validateForm.addEventListener('submit', handleValidateCodeSubmit);
    }

    // Manejo del formulario de login
    const loginForm = document.getElementById('login-form');
    if (loginForm) {
        loginForm.addEventListener('submit', handleLoginSubmit);
    }

    // Manejo del formulario de forgot-password-form
    const forgotPasswordForm = document.getElementById('forgot-password-form');
    if (forgotPasswordForm) {
        forgotPasswordForm.addEventListener('submit', handleForgotPasswordForm);
    }

    if (email && emailLogin) {
        emailLogin.value = email;
    }
});
